export const CandidateEducationLevelOptions = [
    { label: 'Sin estudios', value: 'Sin estudios', code_sorttime: 'SEÑ000' },
    { label: 'Primaria', value: 'Primaria', code_sorttime: 'SEÑ001' },
    { label: 'Bachillerato sin finalizar', value: 'Bachillerato sin finalizar', code_sorttime: 'SEÑ007' },
    { label: 'Bachillerato finalizado', value: 'Bachillerato finalizado', code_sorttime: 'SEÑ002' },
    { label: 'Técnico', value: 'Técnico', code_sorttime: 'SEÑ003' },
    { label: 'Tecnólogo', value: 'Tecnólogo', code_sorttime: 'SEÑ004' },
    { label: 'Profesional', value: 'Profesional', code_sorttime: 'SEÑ005' },
    { label: 'Especialista', value: 'Especialista', code_sorttime: 'SEÑ006' },
    { label: 'Sin definir', value: 'Sin definir', code_sorttime: 'SEÑ008' },
  ];

  export const ProfileEducationLevelOptions = [
    
    {label: 'No requiere', value: '0'},
    {label: 'Básica Primaria', value: '1'},
    {label: 'Bachillerato', value: '2'},
    {label: 'Técnica', value: '3'},
    {label: 'Tecnológica', value: '4'},
    {label: 'Profesional', value: '5'},
    {label: 'Especialista', value: '6'},
    {label: 'Maestría', value: '7'},
    {label: 'Doctorado', value: '8'},
      
  ];


// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/shared/constans.ts